module.exports = __webpack_public_path__ + "img/slogan.0d7b94a0.webp";